import { render, staticRenderFns } from "./VendorGrid.vue?vue&type=template&id=764ddf1a"
import script from "./VendorGrid.vue?vue&type=script&lang=js"
export * from "./VendorGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports